module.exports = __webpack_public_path__ + "img/mask.6377bad7.png";